/**
 * CompuMe AI storefront guard
 * Security + operational-truth boundary for dynamic AI content.
 * Uses a child-list-only observer to avoid self-triggering attribute loops.
 */
(function () {
  'use strict';

  var STORE_HOSTS = {
    'compume.jo': true,
    'www.compume.jo': true,
    'bestbuyjor.myshopify.com': true
  };

  var STORE_PHONE_TEL = 'tel:+962798000180';
  var STORE_WHATSAPP = 'https://wa.me/962798000180';
  var STORE_HOURS = 'Sat–Thu 10am–9pm · Fri 5pm–10pm';

  function setAttrIfChanged(el, name, value) {
    if (el && el.getAttribute(name) !== value) el.setAttribute(name, value);
  }

  function setTextIfChanged(el, value) {
    if (el && el.textContent !== value) el.textContent = value;
  }

  function isSafeStoreUrl(raw) {
    if (!raw || typeof raw !== 'string') return false;
    try {
      var url = new URL(raw, window.location.origin);
      var protocol = String(url.protocol || '').toLowerCase();
      var host = String(url.hostname || '').toLowerCase();
      if (protocol !== 'http:' && protocol !== 'https:') return false;
      if (url.origin === window.location.origin) return true;
      if (protocol !== 'https:') return false;
      return STORE_HOSTS[host] === true;
    } catch (e) {
      return false;
    }
  }

  function sanitizeDynamicAiLinks(panel) {
    if (!panel || !panel.querySelectorAll) return;
    var links = panel.querySelectorAll('a.cm-pcard, a.cm-ct-link, a.cm-link');

    Array.prototype.forEach.call(links, function (link) {
      var rawHref = link.getAttribute('href') || '';
      if (link.getAttribute('data-cm-blocked-link') === 'true' && rawHref === '#') return;

      if (isSafeStoreUrl(rawHref)) {
        link.removeAttribute('data-cm-blocked-link');
        link.removeAttribute('aria-disabled');
        return;
      }

      setAttrIfChanged(link, 'href', '#');
      setAttrIfChanged(link, 'data-cm-blocked-link', 'true');
      setAttrIfChanged(link, 'aria-disabled', 'true');
      setAttrIfChanged(link, 'rel', 'noopener noreferrer');
    });
  }

  function syncOperationalTruth(panel) {
    if (!panel) return;

    setAttrIfChanged(panel, 'aria-labelledby', 'cm-hname');
    panel.removeAttribute('aria-describedby');

    var cards = panel.querySelectorAll('.cm-info-card');
    Array.prototype.forEach.call(cards, function (card) {
      var label = card.querySelector('.cm-info-label');
      var value = card.querySelector('.cm-info-val');
      if (!label || !value) return;

      var normalized = String(label.textContent || '').trim().toLowerCase();
      if (normalized === 'hours') setTextIfChanged(value, STORE_HOURS);
      if (normalized === 'whatsapp / call') {
        var phoneLink = value.querySelector('a');
        setAttrIfChanged(phoneLink, 'href', STORE_PHONE_TEL);
      }
    });

    var whatsappCard = panel.querySelector('.cm-wa-card');
    var waHref = STORE_WHATSAPP + '?text=' + encodeURIComponent('Hello CompuMe! I need help finding a product.');
    setAttrIfChanged(whatsappCard, 'href', waHref);

    var whatsappSub = panel.querySelector('.cm-wa-card-sub');
    setTextIfChanged(whatsappSub, '+962 79 800 0180 · ' + STORE_HOURS);
  }

  function enableKeyboardChips(panel) {
    if (!panel || panel.getAttribute('data-cm-keyboard-chips') === 'true') return;
    panel.setAttribute('data-cm-keyboard-chips', 'true');
    panel.addEventListener('keydown', function (event) {
      var chip = event.target && event.target.closest ? event.target.closest('.cm-chip[role="button"]') : null;
      if (!chip || (event.key !== 'Enter' && event.key !== ' ')) return;
      event.preventDefault();
      chip.click();
    });
  }

  function initGuard() {
    var panel = document.getElementById('cm-panel');
    if (!panel) return;

    syncOperationalTruth(panel);
    sanitizeDynamicAiLinks(panel);
    enableKeyboardChips(panel);

    if (panel.getAttribute('data-cm-link-guard') !== 'true') {
      panel.setAttribute('data-cm-link-guard', 'true');
      panel.addEventListener('click', function (event) {
        var blocked = event.target && event.target.closest
          ? event.target.closest('a[data-cm-blocked-link="true"]')
          : null;
        if (!blocked) return;
        event.preventDefault();
        event.stopPropagation();
      }, true);
    }

    if ('MutationObserver' in window && panel.getAttribute('data-cm-observed') !== 'true') {
      panel.setAttribute('data-cm-observed', 'true');
      var scheduled = false;
      var observer = new MutationObserver(function (mutations) {
        var hasAddedNodes = false;
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].type === 'childList' && mutations[i].addedNodes.length) {
            hasAddedNodes = true;
            break;
          }
        }
        if (!hasAddedNodes || scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () {
          scheduled = false;
          sanitizeDynamicAiLinks(panel);
        });
      });
      observer.observe(panel, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGuard, { once: true });
  } else {
    initGuard();
  }
})();
